import { X, Grid3x3 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/LanguageContext";
import { t } from "@/translations";

const NoBlocksModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { lang } = useLanguage();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}
      onClick={onClose}
      data-testid="no-blocks-modal-overlay"
    >
      <div
        className="bg-[#1E293B] border-2 border-[#F59E0B] p-8 max-w-sm w-[90%] text-center relative"
        onClick={(e) => e.stopPropagation()}
        data-testid="no-blocks-modal"
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-[#64748B] hover:text-white transition-colors"
          aria-label="Close"
          data-testid="no-blocks-modal-close"
        >
          <X size={20} />
        </button>
        <Grid3x3 size={48} className="text-[#F59E0B] mx-auto mb-4" />
        <h3 className="font-heading font-bold text-white text-lg mb-2">
          {t("noBlocks.title", lang)}
        </h3>
        <p className="text-[#94A3B8] text-sm mb-6">
          {t("noBlocks.message", lang)}
        </p>
        <button
          onClick={() => {
            onClose();
            navigate("/");
            setTimeout(() => {
              const grid = document.querySelector(".pixel-grid");
              if (grid) grid.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 300);
          }}
          className="btn-primary w-full flex items-center justify-center gap-2"
          data-testid="no-blocks-go-to-grid"
        >
          <Grid3x3 size={18} />
          {t("noBlocks.goToGrid", lang)}
        </button>
      </div>
    </div>
  );
};

export default NoBlocksModal;
